export const cropCurrencyName = (name: string) => {
  if (!name) return '-';
  let result = '';
  const split = name.split(' ');
  split.forEach((s) => {
    result += s.substring(0, 1);
  });
  return result.toUpperCase();
};
